const devOpt = {
  cApiDomain: '//mock.xiaojukeji.com/mock/822',
  actApiDomain: '//mock.xiaojukeji.com/mock/822',
  entregaApiDomain: '//mock.xiaojukeji.com/mock/822',
  fulfillmentApiDomain: '//mock.xiaojukeji.com/mock/822',
  vfmApiDomain: '//mock.xiaojukeji.com/mock/12440'
}
export default devOpt
